import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import TextArea from "antd/es/input/TextArea";

const UpdateTerms = ({ visible, onCancel, term, onUpdate }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [contentItems, setContentItems] = useState([
    { question: "", description: "" },
  ]);

  useEffect(() => {
    if (visible) {
      if (term) {
        form.setFieldsValue({
          creator: term?.creator?._id,
        });
        if (term.data && Array.isArray(term.data)) {
          setContentItems(term.data);
        } else {
          setContentItems([{ question: "", description: "" }]);
        }
      } else {
        form.resetFields();
        setContentItems([{ question: "", description: "" }]);
      }
    }
  }, [visible, term, form]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true); // Start loader
        const requestBody = { ...values, data: contentItems };

        const getRes = (res) => {
          setIsLoading(false); // Stop loader
          if (res.status === 200) {
            GreenNotify(
              term
                ? "Terms and Conditions Updated Successfully"
                : "Terms and Conditions Created Successfully"
            );
            onCancel();
            onUpdate(requestBody);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        };

        const apiCall = term
          ? callApi(
              "PATCH",
              `${routes.updateTermsOfUse}/${term._id}`,
              requestBody,
              setIsLoading,
              getRes
            )
          : callApi(
              "POST",
              `${routes.createTermsAndConditions}`,
              requestBody,
              setIsLoading,
              getRes
            );

        apiCall.catch((error) => {
          console.error("API call error", error);
          setIsLoading(false); // Stop loader on error
          RedNotify(
            "An error occurred during the API call. Please try again later."
          );
        });
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
      });
  };

  const handleContentChange = (index, field, value) => {
    const updatedContentItems = [...contentItems];
    updatedContentItems[index][field] = value;
    setContentItems(updatedContentItems);
  };

  const addContentItem = () => {
    setContentItems([...contentItems, { question: "", description: "" }]);
  };

  const removeContentItem = (index) => {
    const updatedContentItems = contentItems.filter((_, i) => i !== index);
    setContentItems(updatedContentItems);
  };

  return (
    <Modal
      title={
        term ? "Update Terms and Conditions" : "Create Terms and Conditions"
      }
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={isLoading}
          disabled={isLoading}
        >
          {term ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        {contentItems.map((item, index) => (
          <div
            key={index}
            style={{
              marginBottom: "1rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ flex: 1 }}>
              <Form.Item
                label={`Question ${index + 1}`}
                rules={[
                  { required: true, message: "Please enter the question" },
                ]}
              >
                <Input
                  value={item.question}
                  onChange={(e) =>
                    handleContentChange(index, "question", e.target.value)
                  }
                />
              </Form.Item>
              <Form.Item
                label={`Description ${index + 1}`}
                rules={[
                  { required: true, message: "Please enter the description" },
                ]}
              >
                <TextArea
                  value={item.description}
                  onChange={(e) =>
                    handleContentChange(index, "description", e.target.value)
                  }
                />
              </Form.Item>
            </div>
            {contentItems.length > 1 && (
              <Button
                type="link"
                icon={<MinusCircleOutlined />}
                onClick={() => removeContentItem(index)}
                style={{ marginLeft: 8 }}
                disabled={isLoading}
              />
            )}
          </div>
        ))}
        <Button
          type="dashed"
          onClick={addContentItem}
          style={{ width: "100%", marginBottom: "1rem" }}
          disabled={isLoading}
        >
          <PlusOutlined /> Add Content
        </Button>
      </Form>
    </Modal>
  );
};

export default UpdateTerms;
